import { sendAnalytics } from '@audio-network/analytics'
import { LogoLink } from '@audio-network/componentlibrary'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'

import FurtherInfo from './FurtherInfo/FurtherInfo'
import styles from './Sidebar.module.css'
import YourLibrary from './YourLibrary/YourLibrary'

const Sidebar: React.FC = (props) => {
	const [expanded, setExpanded] = useState<boolean>(true)

	const toggleExpanded = (): void => {
		sendAnalytics({
			noun: 'Sidebar',
			pastTenseVerb: 'Resized',
			eventParameters: {
				// 224 is the default width of the sidebar when expanded
				// 56 is the collapsed width of the sidebar
				Width: !expanded ? 224 : 56,
			},
		})

		setExpanded(!expanded)
	}

	const { t } = useTranslation(['navigation'])

	return (
		<aside
			className={styles.sidebar}
			data-sidebar-expanded={expanded}
			data-testid="sidebar"
			{...props}
		>
			<div className={clsx(styles.sidebarContent, expanded && styles.expanded)}>
				<LogoLink
					aria-label="Audio Network"
					className={clsx(
						styles.logoLink,
						styles.roundel,
						styles.hideWhenExpanded
					)}
					href="/"
					color="yellow"
					roundel
				/>

				<LogoLink
					aria-label="Audio Network"
					className={clsx(
						styles.logoLink,
						styles.logo,
						styles.showWhenExpanded
					)}
					href="/"
					color="white"
				/>
				<YourLibrary />
				<FurtherInfo />
			</div>

			<button
				aria-label={t('resize-navigation-drawer')}
				className={styles.sidebarDrag}
				onClick={toggleExpanded}
				type="button"
				tabIndex={0}
			/>
		</aside>
	)
}

export default Sidebar
